import React from 'react';
import YouTubeAudioPlayer from './components/YoutubeAudioPlayer';

function App() {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <YouTubeAudioPlayer />
    </div>
  );
}

export default App;